import React, { useCallback } from 'react';

import { ProductSearch } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/ProductSearch';
import { useInitialFilter } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/TrimMenu/useInitialFilter';
import { useBuildingDesigner } from 'src/modules/designStudio/helpers/machete/useBuildingDesigner';
import type { Variation } from 'src/modules/designStudio/helpers/productSelection/types';
import { ProductCategory } from 'src/modules/designStudio/helpers/productSelection/types';

export const TrimMenu = ({
  closeMenu,
  headerText,
}: {
  headerText: string | null;
  closeMenu: () => void;
}) => {
  const { mutateBuilding } = useBuildingDesigner();
  const initialFilter = useInitialFilter();

  const onVariationSelected = useCallback(
    (variation: Variation) => {
      mutateBuilding(async mutations => {
        await mutations.changeTrimAppearances([{}], {
          textureId: variation.textureId,
          color: variation.color?.hex,
          variationUUID: variation.uuid,
        });
      });
    },
    [mutateBuilding],
  );

  return (
    <ProductSearch
      category={ProductCategory.TRIM}
      initialFilter={initialFilter}
      onBack={closeMenu}
      onVariationSelected={onVariationSelected}
      title={headerText as string}
    />
  );
};
